import { useCallback, useState } from "react";

export function useDirtyTabs() {
  const [dirtyTabs, setDirtyTabs] = useState<Set<string>>(new Set());

  const markDirty = useCallback((tab: string, dirty: boolean) => {
    setDirtyTabs((prev) => {
      const next = new Set(prev);
      if (dirty) next.add(tab);
      else next.delete(tab);
      return next;
    });
  }, []);

  const clear = useCallback(() => {
    setDirtyTabs(new Set());
  }, []);

  return { dirtyTabs, markDirty, clear };
}
